import { ObservableArray, View } from "binder"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { ServerSideDataLoader } from "uicomponents";
import { InternalTransfer, InternalTransferEnumProvider, InternalTransferListViewModel } from "./internalTransferList-viewModel"

export class InternalTransferListView extends View<InternalTransferListViewModel>{
    GetViewUniqueId(): string {
        return "V-3675B3AB-14C1-451E-B639-6D3FEFE7EFCF"
    }
    loadHtml(): string {
        let element = require('./internalTransferList.html').default;
        let style = require('./internalTransferList.less');
        return element;
    }
    constructor() {
       super();
    }

    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set internalTransfers(v: ObservableArray<InternalTransfer>) { this._internalTransfer = v; } public get internalTransfers(): ObservableArray<InternalTransfer> { return this._internalTransfer;} private _internalTransfer: ObservableArray<InternalTransfer>;
    public set internalTransferEnumProvider(v: InternalTransferEnumProvider) { this._internalTransferEnumProvider = v; } public get internalTransferEnumProvider(): InternalTransferEnumProvider { return this._internalTransferEnumProvider;} private _internalTransferEnumProvider: InternalTransferEnumProvider;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup;} private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup;} private _popup: IPopup;  
 
    createInternalTransfer () {
        this.dataContext.createInternalTransfer();
    }
 
    createCodeConversion () {
        this.dataContext.createCodeConversion();
    }
}
